import { useNavigate } from "react-router-dom";

import { PersonalisationAdvisorBenefits } from "modules/personalisation/components/PersonalisationInfoCards";
import { ChooseYourAIAdvisorContainer_PATH } from "modules/personalisation/containers/ChooseYourAIAdvisorContainer";
import { ImproveConcernsContainer_PATH } from "modules/personalisation/containers/ImproveConcernsContainer";
import { usePersonalisationData } from "modules/personalisation/context/PersonalisationDataContext";

export const PersonalisationAdvisorBenefitsContainer_PATH = "/personalise/info-cards" as const;

export function PersonalisationAdvisorBenefitsContainer() {
  const navigate = useNavigate();
  const { skipAdvisor } = usePersonalisationData();

  return (
    <PersonalisationAdvisorBenefits
      onContinue={() => navigate(ChooseYourAIAdvisorContainer_PATH)}
      onSkip={() => {
        skipAdvisor();
        navigate(ImproveConcernsContainer_PATH);
      }}
    />
  );
}
